<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ScheduleBaseRevised from '../../../../schedule/components/ScheduleBaseRevised.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        useFullContainer: true,
        hideLeftColumn: false,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Shifts',
                route: '/(app)/schedule/shifts/',
            },
            {
                label: 'New Shift',
                route: '/(app)/schedule/shifts.wizard',
            },
            {
                label: 'Activity',
                route: '/(app)/schedule/activity/',
            },
            {
                label: 'Calendar',
                route: '/(app)/schedule/calendar/',
            }
        ],
    }
})
</script>

<template>
  <ScheduleBaseRevised />
</template>